<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="dialogClose" width="600px">
    <el-form :model="form" label-width="220px" label-position="right" :rules="rules" ref="ruleForm" class="settlement-form mt20">
      <el-form-item label="净利润（万元）：" prop="netProfit">
        <el-input v-model="form.netProfit" size="mini" placeholder="请输入净利润（万元）" />
      </el-form-item>
      <el-form-item label="期末员工数：" prop="personnelNumber">
        <el-input v-model="form.personnelNumber" size="mini" placeholder="请输入期末员工数" />
      </el-form-item>
      <el-form-item label="运输周转量：" prop="turnover">
        <el-input v-model="form.turnover" size="mini" placeholder="请输入运输周转量" />
      </el-form-item>
      <el-form-item label="运输里程：" prop="distance">
        <el-input v-model="form.distance" size="mini" placeholder="请输入运输里程" />
      </el-form-item>
      <el-form-item label="能耗种类、数量、计量单位：" prop="meteringCompany">
        <el-input v-model="form.meteringCompany" size="mini" placeholder="请输入能耗种类、数量、计量单位" />
      </el-form-item>
      <div class="flex-center-center mt10 mb20">
        <el-button size="medium" class="searchBtn" :loading="submitLoading" @click="submit"> 确认 </el-button>
        <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { monthlySummaryDataEcho, monthlySummaryUpdate } from '@/service/financial';

  export default {
    name: 'yearAndMonthSummaryForm',
    data() {
      return {
        dialogTitle: '新增',
        dialogVisible: false,
        defaultForm: {},
        form: {
          id: '',
          basicId: '',
          netProfit: '',
          personnelNumber: '',
          meteringCompany: '',
          turnover: '',
          distance: '',
        },
        rules: {
          netProfit: [
            {
              required: true,
              message: '请输入净利润（万元）',
              trigger: 'blur',
            },
          ],
          personnelNumber: [
            {
              required: true,
              message: '请输入期末员工数',
              trigger: 'blur',
            },
          ],
          turnover: [
            {
              required: true,
              message: '请输入运输周转量',
              trigger: 'blur',
            },
          ],
          distance: [
            {
              required: true,
              message: '请输入运输里程',
              trigger: 'blur',
            },
          ],
          meteringCompany: [
            {
              required: true,
              message: '请输入能耗种类、数量、计量单位',
              trigger: 'blur',
            },
          ],
        },
        submitLoading: false,
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      async getDetails(id) {
        this.form.id = id;
        const { status, message, data } = await monthlySummaryDataEcho(id);
        if (status !== 0) return this.$message.warning(message);
        this.form = data;
      },
      dialogOpen(title, row) {
        this.dialogTitle = title;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.form.basicId = row.id
        this.form.id = row.subtableId;
        if (title === '编辑') this.getDetails(row.subtableId);
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            this.submitLoading = true;
            const { status, message } = await monthlySummaryUpdate(this.form);
            this.submitLoading = false;
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .settlement-form {
    width: 80%;
    margin: 0 auto;
  }

  .el-date-editor.el-input,
  .el-select--mini {
    width: 100%;
  }
</style>
